module.exports = __webpack_public_path__ + "img/company-sosiago.d9ab30b3.png";